export const CANVAS_WORKSPACE_BG = "#F4F4F5";
export const CANVAS_ARTBOARD_BG = "#FFFFFF";
export const CANVAS_ARTBOARD_BORDER = "1px solid rgba(24, 24, 27, 0.38)";
export const CANVAS_ARTBOARD_SHADOW =
  "0 1px 2px rgba(0, 0, 0, 0.14), 0 10px 28px rgba(0, 0, 0, 0.12)";

export const canvasWorkspaceSx = {
  bgcolor: CANVAS_WORKSPACE_BG,
};

export const canvasZoomViewportSx = {
  overflow: "auto",
  overscrollBehavior: "contain",
  overflowAnchor: "none",
  '&[data-canvas-pan="grab"], &[data-canvas-pan="grab"] *': {
    cursor: "grab !important",
  },
  '&[data-canvas-pan="grabbing"], &[data-canvas-pan="grabbing"] *': {
    cursor: "grabbing !important",
  },
};

export const canvasZoomHideScrollbarsSx = {
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": { display: "none" },
};

export const canvasArtboardSx = {
  bgcolor: CANVAS_ARTBOARD_BG,
  border: CANVAS_ARTBOARD_BORDER,
  boxShadow: CANVAS_ARTBOARD_SHADOW,
};

export const RESIZABLE_MULTILINE_MIN_ROWS = 3;

export const resizableMultilineSx = {
  "& .MuiInputBase-inputMultiline": {
    resize: "vertical",
    overflowY: "auto",
  },
};
